import api from './http'

/* *****문의하기 FRONT API***** */

// uploadAttachFile
const saveUpload = (data, mail, callback, errorHandler) => {
  return api.getPromise('POST', '/api/question/attach-upload', data, { params: mail })
}

// sendQuestion
const saveQuestion = (data, callback, errorHandler) => {
  return api.getPromise('POST', '/api/question/send', data)
}

export default {
  saveUpload,
  saveQuestion,
}
